/** @format */

import {Box} from '@mui/material';
import {styled} from '@mui/material/styles';

import {providerIconSrc} from 'helpers/imageHelpers';

import {OauthProvider} from 'graphql/generated/types';

const PREFIX = 'ConnectedProviders';

const classes = {
  icon: `${PREFIX}-icon`,
};

const StyledBox = styled(Box)(({theme}) => ({
  [`& .${classes.icon}`]: {
    marginLeft: theme.spacing(1),
  },
}));

interface TokenWithProvider {
  provider: OauthProvider;
}

interface Props<T> {
  size: number;
  adTypes: string[];
  tokens: ReadonlyArray<T>;
  disabled: boolean;
}

const ConnectedProviders = <T extends TokenWithProvider>({
  size,
  disabled,
  adTypes,
  tokens,
}: Props<T>) => {
  return (
    <StyledBox
      sx={{
        alignItems: 'center',
        display: 'flex',
      }}
    >
      <Box
        sx={{
          height: size,
        }}
      />
      {adTypes.includes('CONTEXT') && (
        <>
          {tokens.find(v => v.provider === 'YANDEX') && (
            <img
              alt='Icon'
              className={classes.icon}
              height={`${size}`}
              src={providerIconSrc('YANDEX', size, disabled)}
              width={`${size}`}
            />
          )}
          {tokens.find(v => v.provider === 'GOOGLE') && (
            <img
              alt='Icon'
              className={classes.icon}
              height={`${size}`}
              src={providerIconSrc('GOOGLE', size, disabled)}
              width={`${size}`}
            />
          )}
        </>
      )}
      {adTypes.includes('TARGET') && (
        <>
          {tokens.find(v => v.provider === 'VKONTAKTE') && (
            <img
              alt='Icon'
              className={classes.icon}
              height={`${size}`}
              src={providerIconSrc('VKONTAKTE', size, disabled)}
              width={`${size}`}
            />
          )}
          {tokens.find(v => v.provider === 'VKONTAKTE_ADS') && (
            <img
              alt='Icon'
              className={classes.icon}
              height={`${size}`}
              src={providerIconSrc('VKONTAKTE_ADS', size, disabled)}
              width={`${size}`}
            />
          )}
          {tokens.find(v => v.provider === 'FACEBOOK') && (
            <img
              alt='Icon'
              className={classes.icon}
              height={`${size}`}
              src={providerIconSrc('FACEBOOK', size, disabled)}
              width={`${size}`}
            />
          )}
        </>
      )}
      {adTypes.includes('STATS') && (
        <>
          {tokens.find(v => v.provider === 'METRIKA') && (
            <img
              alt='Icon'
              className={classes.icon}
              height={`${size}`}
              src={providerIconSrc('METRIKA', size, disabled)}
              width={`${size}`}
            />
          )}
        </>
      )}
    </StyledBox>
  );
};

ConnectedProviders.defaultProps = {
  disabled: false,
};

export default ConnectedProviders;
